import React from 'react';
import { BrewArt } from './cartoon/Art';

const passos = [
    ['Na medida', '10 g de pó (1 colher de sopa cheia) para cada 150 ml de água.'],
    ['Água sem ferver', 'Desligue o fogo quando começar a borbulhar e espere 30 segundos.'],
    ['Deixe o pó "acordar"', 'Molhe o pó com um pouquinho de água e espere 30 segundos.'],
    ['Devagar e em círculos', 'Despeje o resto aos poucos. Pronto: sem açúcar já fica bom.'],
];

export default function Preparo() {
    return (
        <section className="lc lc-section bg-preto" id="preparo">
            <div className="lc-wrap lc-grid-2">
                <div>
                    <span className="lc-pill" style={{ color: 'var(--lc-lil)' }}>dica de preparo</span>
                    <h2 className="lc-title">Coado gostoso em casa<span className="lc-dot">.</span></h2>
                    <ol className="lc-steps" style={{ listStyle: 'none', padding: 0 }}>
                        {passos.map(([titulo, texto], i) => (
                            <li key={titulo} className="lc-step">
                                <span className="lc-step-n" aria-hidden="true">{i + 1}</span>
                                <div>
                                    <h3>{titulo}</h3>
                                    <p>{texto}</p>
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>
                <div>
                    <BrewArt />
                </div>
            </div>
        </section>
    );
}
